module.exports = __webpack_public_path__ + "img/csat.015d2eb6.png";